(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/play/page.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/play/page.js');
"use strict";


const _React = React,
  createContext = _React.createContext,
  useEffect = _React.useEffect;
const useTicketInfo = svs.eInstant.shared.hooks.useTicketInfo;
const _ReactRouterDOM = ReactRouterDOM,
  matchPath = _ReactRouterDOM.matchPath,
  useHistory = _ReactRouterDOM.useHistory;
const PlayContext = createContext();
setGlobal('svs.eInstant.lobby.play.PlayContext', PlayContext);
const PlayProvider = _ref => {
  let children = _ref.children,
    ticketInfo = _ref.ticketInfo,
    isDemo = _ref.isDemo,
    wager = _ref.wager;
  return React.createElement(PlayContext.Provider, {
    value: {
      wager,
      ticketInfo,
      isDemo
    }
  }, children);
};
const Play = _ref2 => {
  let match = _ref2.match;
  const _svs$eInstant$constan = svs.eInstant.constants.ROUTES,
    BET_DETAIL = _svs$eInstant$constan.BET_DETAIL,
    DEMO_PLAY = _svs$eInstant$constan.DEMO_PLAY,
    PLAY = _svs$eInstant$constan.PLAY;
  const Background = svs.eInstant.shared.components.Background;
  const GameLauncherLEIA = svs.eInstant.lobby.play.leia.GameLauncher;
  const gameId = match.params.gameId;
  const history = useHistory();
  const betDetailRoute = matchPath(match.path, {
    path: BET_DETAIL,
    exact: true
  });
  const LEIA = svs.eInstant.lobby.play.utils.GAME_PROVIDERS.LEIA;
  const isDemo = match.path.includes('provspela');
  const wager = svs.eInstant.data.wager && betDetailRoute ? svs.eInstant.data.wager : null;
  const _useTicketInfo = useTicketInfo({
      wager,
      gameId
    }),
    _useTicketInfo$ticket = _useTicketInfo.ticketInfo,
    ticketInfo = _useTicketInfo$ticket === void 0 ? null : _useTicketInfo$ticket,
    loading = _useTicketInfo.loading;
  const _svs$eInstant$shared$ = svs.eInstant.shared.hooks.useMetaTags({
      ticketInfo
    }),
    update = _svs$eInstant$shared$.update;
  useEffect(() => {
    ticketInfo && update(isDemo ? DEMO_PLAY : PLAY);
  }, [ticketInfo]);
  if (!ticketInfo && !loading) {
    gameId && svs.eInstant.logger.warn("failed to start game with gameId: ".concat(gameId));
    svs.ticketgames.ticketUtility.utils.showGameClosedDialog({
      onClose: () => {
        history.push(svs.eInstant.constants.ROUTES.LOBBY);
      }
    });
    return null;
  }
  if (!ticketInfo && loading) {
    return React.createElement(Background, null);
  }
  const gameProvider = ticketInfo.gameProvider;
  return React.createElement(Background, null, React.createElement(PlayProvider, {
    isDemo: isDemo,
    ticketInfo: ticketInfo,
    wager: wager
  }, gameProvider === LEIA && React.createElement(GameLauncherLEIA, null)));
};
setGlobal('svs.eInstant.lobby.Play', Play);

 })(window);